// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Emotion from "../../bindings/Emotion.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function Switch$Switch(props) {
  let __className = props.className;
  let ariaLabel = props.ariaLabel;
  let label = props.label;
  let __disabled = props.disabled;
  let onChange = props.onChange;
  let __checked = props.checked;
  let checked = __checked !== undefined ? __checked : false;
  let disabled = __disabled !== undefined ? __disabled : false;
  let className = __className !== undefined ? __className : "";
  let trackStyles = Emotion.Css.css({
    position: "relative",
    width: "2.5rem",
    height: "1.375rem",
    borderRadius: Emotion.Utils.Border.getRadius("full"),
    border: "none",
    padding: "0",
    flexShrink: "0",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? "0.5" : "1",
    backgroundColor: checked ? Emotion.Utils.Color.primary : Emotion.Utils.Color.border,
    transition: `background-color ` + Emotion.Utils.Animate.getDuration("fast") + ` ease-out`,
    ":focus-visible": {
      outline: "none",
      boxShadow: Emotion.Utils.Shadow.getFocusShadow("primary")
    }
  });
  let thumbStyles = Emotion.Css.css({
    position: "absolute",
    top: "0.125rem",
    left: checked ? "1.25rem" : "0.125rem",
    width: "1.125rem",
    height: "1.125rem",
    borderRadius: Emotion.Utils.Border.getRadius("full"),
    backgroundColor: Emotion.Utils.Color.textInverse,
    transition: `left ` + Emotion.Utils.Animate.getDuration("fast") + ` ease-out`,
    pointerEvents: "none"
  });
  let wrapStyles = Emotion.Css.cx([
    Emotion.Css.css({
      display: "inline-flex",
      alignItems: "center",
      gap: "0.75rem"
    }),
    className
  ]);
  let handleClick = _evt => {
    if (!disabled && onChange !== undefined) {
      return onChange(!checked);
    }
  };
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("button", {
        children: JsxRuntime.jsx("span", {
          className: thumbStyles
        }),
        "aria-label": ariaLabel !== undefined ? ariaLabel : (
            label !== undefined ? label : "Toggle"
          ),
        "aria-checked": checked ? "true" : "false",
        className: trackStyles,
        role: "switch",
        disabled: disabled,
        type: "button",
        onClick: handleClick
      }),
      label !== undefined ? JsxRuntime.jsx("span", {
          children: label,
          className: Emotion.Css.css({
            fontSize: "0.875rem",
            color: Emotion.Utils.Color.textPrimary
          })
        }) : null
    ],
    className: wrapStyles
  });
}

let Switch = {
  make: Switch$Switch
};

export {
  Switch,
}
/* Emotion Not a pure module */
